"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeTimeObject = void 0;
const TimeObject_1 = require("../entity/AdAnalyticsVideo/TimeObject");
const createSomeTimeObject = ({ hours = 0, minutes = 1, seconds = 10, } = {}) => new TimeObject_1.default({ hours, minutes, seconds });
exports.createSomeTimeObject = createSomeTimeObject;
